import React from 'react';
import PropTypes from 'prop-types';
import 'apps/hiring/styles/components/add-behaviors.scss';
import SubscriptionInviteModal from 'library/components/employee-select-modal';
import { InputEvent as SyntheticEvent } from 'library/helpers/synthetic-events';

const AddEmployees = (props) => (
  <button style={{width: '100%', justifyContent: 'center'}} {...props}>
    ADD
    <span> + </span>
  </button>
);

class EditEmployeeList extends React.Component {
  mapMembers = ({ id, name }) => (
    <div key={id} className="hiring-behavior-row">
      <span>{ name }</span>
      <div>
        <button onClick={()=>this.remove(id)}>REMOVE</button>
      </div>
    </div>
  )

  handleAddTargets = (users) => {
    this.props.onChange(new SyntheticEvent({
      name: this.props.addType,
      value: [...this.props.users,...users].filter((v,i,a)=>a.findIndex(x=>x.id===v.id)===i)
    }));
  }

  remove = (id) => {
    this.props.onChange(new SyntheticEvent({
      name: this.props.addType,
      value: [...this.props.users].filter((v)=>v.id!==id)
    }));
  }

  render() {
    const {
      users,
      title,
      buttonText,
      surveyed=false
    } = this.props;

    return (
      <div className="add-behaviors">
        <h2> {title} </h2>
        <div className="add-behaviors-header">
          <SubscriptionInviteModal
            surveyed={surveyed}
            handleSumbit={this.handleAddTargets}
            upperButtonText={buttonText}
            buttonText='Add'
            title={'Add Employee'}
            component={AddEmployees}
            exclude={users.map(c => c.id)}
          />
        </div>
        <div className="add-behaviors-body">
          {
            users.map(this.mapMembers)
          }
        </div>
      </div>
    );
  }
}

EditEmployeeList.propTypes ={
  users : PropTypes.array,
  name: PropTypes.string,
  onChange: PropTypes.func,
  addType: PropTypes.string,
  title: PropTypes.string,
  buttonText: PropTypes.string,
  surveyed: PropTypes.bool
};

export default EditEmployeeList;
